import React, {memo} from 'react';
import cn from 'classnames';
import {useSelector} from 'react-redux';
import {TemperatureUnit} from '@/common/constants/units';
import {temperatureReduce} from '@/common/helpers/unitReducers/temperatureReduce';
import {selectTemperatureUnit} from '@/app/store/config/selectors';
import styles from './WeatherThermometer.css';

const scaleRanges: Record<TemperatureUnit, number[]> = {
	[TemperatureUnit.celsius]: [40, 20, 0, -20, -40],
	[TemperatureUnit.fahrenheit]: [120, 80, 40, 0, -40],
};

interface WeatherThermometerProps {
	className?: string;
	temperature: number;
}

export const WeatherThermometer = memo<WeatherThermometerProps>(props => {
	const {className, temperature} = props;
	const temperatureUnit = useSelector(selectTemperatureUnit);

	const scaleRange = scaleRanges[temperatureUnit];
	const scaleRangeStart = scaleRange[0];
	const scaleRangeEnd = scaleRange[scaleRange.length - 1];
	const temperatureInLocalInit = temperatureReduce(temperature, temperatureUnit);
	const thermScaleValue = ((temperatureInLocalInit - scaleRangeEnd) / (scaleRangeStart - scaleRangeEnd)) * 100;

	return (
		<div className={cn(styles.root, className)}>
			{scaleRange.join('\n')}
			<div className={styles.scale} style={{backgroundSize: `100% ${thermScaleValue}%`}} />
		</div>
	);
});

WeatherThermometer.displayName = 'WeatherThermometer';
